<template>
  <div style="width:100%;height:100%">
    <div class="bigbox">
      <div class="top clearfix">
        <div class="topbg"></div>
        <div class="topbtn" @click="btnshow"></div>
      </div>
      <div class="tables">
        <el-table
          :data="table34Data"
          style="width:100%;;font-size:12px;marginTop:50px"
          height="300"
          border
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column align="center" prop="WarnningTypeString"  label="类型">
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.WarnningTypeString}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.WarnningTypeString}}</span>
              <span v-else>{{scope.row.WarnningTypeString}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="MaterialCode"  label="物料编号">
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.MaterialCode}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.MaterialCode}}</span>
              <span v-else>{{scope.row.MaterialCode}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="Remark"
            label="报警时间"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.Remark}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.Remark}}</span>
              <span v-else>{{scope.row.Remark}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="police"
            label="报警状态"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.police}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.police}}</span>
              <span v-else>{{scope.row.police}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="bottomfenye">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          small
          :page-size="pagesize"
          layout="prev, pager, next"
          :total="total"
          :current-page="pagenumber"
        ></el-pagination>
      </div> -->
    </div>
     <el-dialog title="预警记录" :visible.sync="centerDialog34" width="900px" center>
        <div class="tables">
        <el-table
          :data="table34Data"
          style="width:100%;background:#fff;font-size:16px;"
          height="340"
          border
          :row-style="tableRowStylelog"
          :header-cell-style="tableHeaderColorlog"
        >
          <el-table-column align="center" prop="WarnningTypeString" label="类型">
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.WarnningTypeString}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.WarnningTypeString}}</span>
              <span v-else>{{scope.row.WarnningTypeString}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="MaterialCode" label="物料编号">
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.MaterialCode}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.MaterialCode}}</span>
              <span v-else>{{scope.row.MaterialCode}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="Remark"
            label="报警时间"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.Remark}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.Remark}}</span>
              <span v-else>{{scope.row.Remark}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="police"
            label="报警状态"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span v-if="scope.row.bid=='1'" style="color: #C02425">{{scope.row.police}}</span>
              <span v-else-if="scope.row.bid=='2'" style="color:#AB894C">{{scope.row.police}}</span>
              <span v-else>{{scope.row.police}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="bottomfenye">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :page-size="pagesize"
          layout="prev, pager, next"
          :total="total"
          :current-page="pagenumber"
        ></el-pagination>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "echarts34",
  props: {
    table34Data: {
      type: Array,
      default: () => {
        return [
          {
            bid: "1",
            WarnningTypeString: "呆滞",
            MaterialCode: "七匹狼",
            Remark: "13:50:23",
            police: "报警中"
          },
          {
            bid: "2",
            WarnningTypeString: "盘盈",
            MaterialCode: "七匹狼",
            Remark: "13:50:23",
            police: "处理中"
          },
          {
            bid: "3",
            WarnningTypeString: "盘盈",
            MaterialCode: "七匹狼",
            Remark: "13:50:23",
            police: "已处理"
          },
          {
            bid: "2",
            WarnningTypeString: "盘盈",
            MaterialCode: "七匹狼",
            Remark: "13:50:23",
            police: "已处理"
          },
          {
            bid: "3",
            WarnningTypeString: "盘盈",
            MaterialCode: "七匹狼",
            Remark: "13:50:23",
            police: "已处理"
          },
          {
            bid: "1",
            WarnningTypeString: "盘盈",
            MaterialCode: "七匹狼",
            Remark: "13:50:23",
            police: "已处理"
          },
          {
            bid: "3",
            WarnningTypeString: "盘盈",
            MaterialCode: "七匹狼",
            Remark: "13:50:23",
            police: "已处理"
          }
        ];
      }
    },
    total: {
      type: Number,
      default: 100
    },
    // pagesize: {
    //   type: Number,
    //   default: 7
    // },
    // pagenum: {
    //   type: Number,
    //   default: 1
    // }
  },
  data() {
    return {
      pagenumber: 0,
      pagesize:7,
      centerDialog34:false
    };
  },
  watch: {
    data() {
      //   this.pagenumber();
      //   deep: true;
    }
  },
  methods: {
    //小按钮事件
    btnshow() {
        this.centerDialog34 = true
    },
    tableRowStyle() {
      return "background-color:#dcf4f8;color: #3d8875;height:30px; ";
    },
    // 修改table header的背景色
    tableHeaderColor({ rowIndex }) {
      //   if (rowIndex === 0) {
      return "background-color: #dcf4f8;color: #3d8875;border:none;height:30px;border-right:1px solid #fff;border-bottom:1px solid #fff;box-sizing:border-box;";
      //   }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      //   this.pagenum = val;
      //把当前页传递给父组件
      this.$emit("watchpage", val);
    },
       tableRowStylelog() {
      return "background-color:#DCF4F8;color: #3d8875;height:42px;padding:0; ";
    },
    // 修改table header的背景色
    tableHeaderColorlog({ rowIndex }) {
      //   if (rowIndex === 0) {
      return "background-color: #DCF4F8;color: #3d8875;height:40px;border-right:1px solid #fff;border-bottom:1px solid #fff;box-sizing:border-box;";
      //   }
    }
  }
};
</script>
<style scoped>
.bigbox {
  /* width: 372px;
  height: 338px; */
  width: 100%;
  height: 100%;
  position: relative;
  border: 1px solid #479ea7;
  box-sizing: border-box;
}
.top {
  width: 100%;
  height: 50px;
  position: absolute;
  top: 0;
}
.topbg {
  width: 162px;
  height: 20px;
  background: url("../../assets/img/echarts34-01.png") no-repeat;
  margin: 0 auto;
  margin-top: 15px;
}
.topbtn {
  width: 19px;
  height: 19px;
  background: url("../../assets/img/echarts34-02.png") no-repeat;
  position: absolute;
  right: 6px;
  top: 15px;
}
.tables >>> .el-table td,
.el-table th {
  padding: 0;
}

.tables >>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  border: none;
  width: 0;
  background: transparent;
}
.tables >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #3d8875 !important;
  color: #fff !important;
}

.tables >>> .el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: #fff;
  box-sizing: border-box;
}
.bottomfenye {
  width: 100%;
  height: 40px;
}
.bottomfenye >>> .el-pagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts34.vue